var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4375108_logo_telegram_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_35-telegram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.4305 5.58297L23.502 24.1099C23.2056 25.4174 22.4327 25.7428 21.3343 25.1269L15.3485 20.716L12.4604 23.4939C12.1408 23.8135 11.8734 24.0809 11.2574 24.0809L11.6874 17.9846L22.7814 7.95982C23.2638 7.52983 22.6768 7.29152 22.0317 7.72157L8.31683 16.3573L2.41241 14.5093C1.12809 14.1083 1.10489 13.225 2.6797 12.609L25.7743 3.71172C26.8435 3.31076 27.7792 3.94992 27.4305 5.58297Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramHamburgerMenu);
export default __webpack_public_path__ + "static/media/telegram-hamburger-menu.587ef89c1990ef7f40e25bd5b65d3e42.svg";
export { ForwardRef as ReactComponent };